<template>
<div>
	<b-btn-group class="pull-right">
		<b-btn variant="primary"
		       v-b-tooltip.hover
		       title="Kavel toevoegen"
		       exact
		       :to="{ name: 'itemAdd' }">
			<i class="fa fa-fw fa-plus"></i>
		</b-btn>
	</b-btn-group>

	<h1 class="display-4">{{ $t('item.items') }}</h1>

	<div class="my-1 row">
		<div class="col-lg-4 col-md-6">
			<b-form-input v-model="filter"
						  autocomplete="off"
			              :placeholder="$t('item.searchPlaceholder')" />


			<select @change="filterData" v-model="pic_count" class="mdb-select my-3 md-form pull-right">
				<option value="-1">Met en zonder foto's</option>
				<option value="0">Met foto's</option>
				<option value="1">Zonder foto's</option>
			</select>

			<b-button :disabled="!sortBy"
			          variant="outline-primary"
			          size="sm"
			          class="my-3"
			          @click="resetSorting(true)">{{ $t('common.resetSort') }}</b-button>
		</div>

		<div class="col-lg-4 col-md-6">
			<autocomplete-person :label="null"
			                     @update:person="onUpdateFilterSeller"
			                     :selected="selectedSellerId"></autocomplete-person>
		</div>



		<div class="col-lg-4 col-md-12">
			<b-pagination-nav :link-gen="linkGen"
			                  :number-of-pages="auctionItems.meta.totalPages"
			                  :value="auctionItems.meta.currentPage"
			                  use-router
			                  class="pull-right" />
		</div>

		<div>

		</div>
	</div>

	<partial-loader :loading="auctionItems.isFetching"></partial-loader>

	<b-table v-if="!auctionItems.isFetching"
			 
			striped
			hover
			show-empty
			:items="auctionItems.items"
			:fields="fields"
			:per-page="parseInt(auctionItems.meta.perPage)"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:no-local-sorting="true"
			:empty-text="$t('item.listEmptyText')"
			:empty-filtered-text="$t('item.listEmptyFilteredText')"
			@sort-changed="onSortingChanged">

		<template v-slot:cell(media)="row">
            <b-img-lazy :width="imgSize" v-if="row.item.media[0]" :src="small(row.item.media[0].url)" class="" />
			<b-img v-else blank blank-color="#ccc" :width="imgSize" :height="imgSize" />
        </template>

		<template v-slot:cell(auction_order_number)="row">
				<span v-if="row.item.auction_order_number">{{ row.item.auction_order_number }}</span>
				<span v-else><i>-</i></span>
        </template>

		<template v-slot:cell(number)="row">
				{{ row.item.seller.code }}-{{ row.item.number }}
        </template>

		<template v-slot:cell(title)="row">
				<strong>{{ row.item.title }}</strong><br>
				<small>{{ row.item.description }}</small>
        </template>

		<template v-slot:cell(category)="row">
		        <span v-if="row.item.category.abbreviation" class="titletip" :class="{on : row.item.id == curHoverID}">{{ row.item.category.title }}</span>
				<span class="afk" @mouseout="curHoverID=false" @mouseover="curHoverID = row.item.id" v-if="row.item.category.abbreviation">{{ row.item.category.abbreviation }}</span>
				<span v-if="!row.item.category.abbreviation">{{ row.item.category.slug }}</span>

        </template>

		<template v-slot:cell(buyer)="row">
			<div v-if="row.item.bid">
				{{ row.item.bid.bid_number }}
			</div>
			<div v-else>
				<i>-</i>
			</div>
        </template>

        <template v-slot:cell(price)="row">
			<div v-if="row.item.bid">
				{{ Math.round(row.item.bid.price) }}
			</div>
			<div v-else>
				<i>-</i>
			</div>
        </template>

		<template v-slot:cell(actions)="row">
			<b-button-group class="pull-right">
				<b-btn class="btn-sm" variant="outline-danger" @click="showDeleteModal(row.item)"><i class="fa fa-fw fa-trash"></i></b-btn><!-- <i class="fa fa-fw fa-print"> </i>--><odbbarcode
						:item="row.item" 
						:aucdates="aucdates"
						:type="'icon'" />
				<b-btn class="btn-sm" variant="outline-primary" :to="{ name: 'item', params: { itemId: row.item.id } }"><i class="fa fa-fw fa-eye"></i></b-btn>
	            <b-btn class="btn-sm" variant="outline-primary" :to="{ name: 'itemEdit', params: { itemId: row.item.id } }"><i class="fa fa-fw fa-edit"></i></b-btn>
			</b-button-group>
        </template>

		<template v-slot:cell(limit)="row">
            <span v-if="row.item.limit">{{ Math.round(row.item.limit) }}</span>
        </template>

		<template v-slot:cell(target_price_1)="row">
            <span v-if="row.item.target_price_1">{{ Math.round(row.item.target_price_1) }}</span>
			<span v-if="row.item.target_price_2">
				<span v-if="row.item.target_price_1">-</span>
				{{ Math.round(row.item.target_price_2) }}
			</span>
        </template>
	</b-table>

	<b-pagination-nav :link-gen="linkGen"
	                  :number-of-pages="auctionItems.meta.totalPages"
	                  :value="auctionItems.meta.currentPage"
	                  use-router
	                  class="pull-right" />

	<delete-dialog-modal ref="deleteModal"
	                     :delete-name="selectedDeleteItemName"
	                     :item="selectedDeleteItem"
	                     :isDeleting="isDeleting"
	                     @confirm="deleteItem"></delete-dialog-modal>
</div>
</template>

<style lang="scss">
table th.sorting{
	white-space: nowrap;
}
.no-wrap{
	white-space: nowrap;
}
.num{
	text-align: right;
}
.afk{
	cursor: pointer;
}
.titletip{
	background:rgba(255,255,255,.97);
	background:#17a2b8;
	padding:12px;
	color:#17a2b8;
	color:white;
	border-radius:3px;
	/*box-shadow:0 0 4px rgba(0,0,0,.3);*/
	position: absolute;
	max-width:240px;
	display:none;
	margin:24px 0 0 -88px;
	&.on{
		display:block;
	}
}
</style>

<script>
import {
	mapGetters,
	mapActions
} from 'vuex'

import { isNil } from 'lodash';
import PartialLoader from '@/components/elements/PartialLoader';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import AutocompletePerson from '@/components/elements/AutocompletePerson';
import { flashSuccess } from '@/helpers/flash-message-helper';
import ItemService from '@/services/item-service';
import AuctionService from '@/services/auction-service';
import RequestHelper from '@/helpers/request-helper';
import { stringifyQuery } from '@/helpers/url-helper';
import { filterParams } from '@/helpers/axios';
import ODBBarcode from '@/components/elements/ODBBarcode';

const requestHelper = new RequestHelper();

export default {
	components: {
		PartialLoader,
		DeleteDialogModal,
		AutocompletePerson,
		'odbbarcode' : ODBBarcode,
	},
	data() {
		return {
			fields: [
				{ key:'media', label: '' },
				{ key:'auction_order_number', label: this.$t('item.auctionOrderNumberList'), sortable: true, class: 'num' },
				{ key:'number', label: this.$t('item.itemNumber').substring(0, 4), sortable: true, class:'no-wrap' },
				{ key:'category.abbreviation', label: this.$t('item.categoryShort').substring(0, 3), sortable: true },
				{ key:'title', label: this.$t('item.title'), sortable: true },
				{ key:'limit', label: `${this.$t('item.limit')} (€)` , class: 'no-wrap num', sortable: true},
				{ key:'target_price_1', label: `${this.$t('item.targetpriceList')} (€)` , class: 'no-wrap num', sortable: true },
				{ key:'buyer', label: this.$t('common.clientBidNumberShort'), sortable: true, class: 'num' },
				{ key:'price', label: `${this.$t('common.bidPrice')} (€)`, sortable: true, class: 'num' },
				{ key:'actions', label: this.$t('common.actions'), class: 'text-right' }
			],
			currentPage: 1,
			perPage: 50,
			sortBy: 'id',
			sortDesc: true,
			filter: '',
			pic_count: '-1',
			filterOptions: {
				sellerId: null
			},
			imgSize: 80,
			isDeleting: false,
			selectedDeleteItem: null,
			selectedSellerId: null,
			curHoverID : false
		}

	},
	computed: {
		...mapGetters([
			'auctionItems'
		]),
		selectedDeleteItemName() {
			if (!this.selectedDeleteItem) return '';

			return 'de kavel ' + this.selectedDeleteItem.title;
		}
	},
	watch: {
		'$route': 'fetchData',
		'filter': 'onFilterChanged'
	},
	methods: {

		...mapActions([
			'fetchAuctionItems',
			'nextPageAuctionItems'
		]),

		small(url){
			let chunk 		= url.split('/');
			let file_name 	= chunk[chunk.length - 1];
			let small_name 	= 'small_' + file_name;

			return url.replace(file_name, small_name);
		},
		/**
		 * Link Gen
		 *
		 * Generate link for pagination
		 *
		 * @param {number} pageNumber
		 * @return {string}
		 */
		linkGen(pageNumber) {
			return stringifyQuery(this.getQuery(pageNumber));
		},

		/**
		 * Filter data
		 *
		 * Get data based on query filter
		 */
		filterData() {

			const path = this.$router.resolve({ query: this.getQuery() }).href;

			requestHelper.delayRequest(500)
				.then(() => this.$router.replace({ path: path }))
				.catch(rejected => {});

		},

		/**
		 * Get query
		 *
		 * Get the object with query data
		 *
		 * @param {number} page optional parameter page
		 * @return {object} 	object with query data
		 */
		getQuery(page) {

			page = page || 1;

			return filterParams({
				page: page,
				filter: this.filter,
				pic_count: this.pic_count,
				sortBy: this.sortBy,
				sortDesc: this.sortDesc,
				sellerId: this.filterOptions.sellerId
			});

		},

		/**
		 * On Filter Changed
		 *
		 * Function that will be called when filter value has changed
		 */
		onFilterChanged() {
			if (this.filter.length > 0) {
				this.sortBy = '_score';
				this.sortDesc = true;
			} else {
				this.sortBy = 'id';
			}

			this.filterData();
		},

		/**
		 * On Sorting Changed
		 *
		 * Set sortBy and sortDesc when sort changes
		 */
		onSortingChanged(ctx) {

			if (ctx.sortBy != null) {
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				this.filterData();
			} else {
				this.resetSorting();
			}

		},

		/**
		 * On update filter seller
		 */
		onUpdateFilterSeller(person) {

			if (person) {
				this.filterOptions.sellerId = person.id;
			} else {
				this.filterOptions.sellerId = null;
			}

			this.filterData();
		},

		/**
		 * Reset Sorting
		 *
		 * Set sorting back to its default values
		 */
		resetSorting() {
			this.sortBy = '_score';
			this.sortDesc = true;
			this.filterData();
		},

		/**
		 * Fetch data
		 */
		fetchData() {
			const params = this.$route.params;
			const query = this.$route.query;

			const currentPage = Number.parseInt(query.page);
			this.currentPage = isNaN(currentPage) ? 1 : currentPage;

			return this.fetchAuctionItems({
				auctionId: params.auctionId,
				params: {
					total: this.perPage,
					page: this.currentPage,
					query: query.filter ? query.filter : '',
					sort: this.sortBy,
					order: this.sortDesc ? 'desc' : 'asc',
					pic_count: this.pic_count,
					personId: this.filterOptions.sellerId
				}
			});
		},

		/**
		 * Show delete modal for the item
		 * @param {Object} item
		 */
		showDeleteModal(item) {
			this.selectedDeleteItem = item;
			this.$refs.deleteModal.show();
		},

		/**
		 * Delete Item
		 *
		 * @param {Object} item
		 */
		deleteItem(item) {

			this.isDeleting = true;

			return ItemService.deleteOne(item.id)
				.then(
					response => {
						this.$refs.deleteModal.hide();
						this.isDeleting = false;
						flashSuccess('Kavel verwijderd');
						this.fetchData();
					}
				)
				.catch(
					error => {
						this.$refs.deleteModal.hide();
						this.isDeleting = false;
						this.error = error.message;
					}
				);
		},

		/**
		 * Get Label
		 *
		 * Open new window with label
		 */
		getLabel(itemId) {
			ItemService.getItemLabel(itemId)
				.then(response => window.open(response, '_blank'));
		},

		/**
		 * Parse query
		 *
		 * Get query from route params and parse it
		 */
		parseQuery() {
			if (this.$route.query.filter)
				this.filter = this.$route.query.filter;

			if (this.$route.query.sortBy)
				this.sortBy = this.$route.query.sortBy;

			if (this.$route.query.sortDesc)
				this.sortDesc = this.$route.query.sortDesc == 'true' ? true : false;

			if (this.$route.query.sellerId) {
				const sellerId = Number(this.$route.query.sellerId);

				this.filterOptions.sellerId = sellerId;
				this.selectedSellerId = sellerId;
			}

		}
	},
	mounted() {
		this.parseQuery();
		this.fetchData();
	},
	props : [
		'aucdates'
	]
}
</script>



// WEBPACK FOOTER //
// ItemList.vue?9f7aa99a